import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.define-properties";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry
*/
import React from 'react';
import Block from 'wfui-digital-core/es/Block';
import Markup from 'wfui-digital-core/es/Markup';
import useLanguage from '../../use-language/use-language';
import useStrings from 'wfui-digital-core/es/useStrings';
import AccessibilityText from 'wfui-digital-core/es/AccessibilityText';
import logger from '../../../lib/logger/logger';
import getLastLogonMessageParts from './support/get-last-logon-message-parts';
import styles from './LastLogon.less';

var getAccessibilityMessage = function getAccessibilityMessage(_ref) {
  var language = _ref.language,
      logonMonth = _ref.logonMonth,
      logonDate = _ref.logonDate,
      logonYear = _ref.logonYear,
      logonTime = _ref.logonTime,
      logonTimezone = _ref.logonTimezone;
  return language === 'sp' ? "La \xFAltima vez que inici\xF3 sesi\xF3n fue el ".concat(logonDate, " de ").concat(logonMonth, " de ").concat(logonYear, " a la(s) ").concat(logonTime, ", ").concat(logonTimezone) : "Your last sign on was ".concat(logonMonth, " ").concat(logonDate, ", ").concat(logonYear, " at ").concat(logonTime, ", ").concat(logonTimezone);
};

var getFormattedMessage = function getFormattedMessage(props) {
  var language = props.language,
      logonMonth = props.logonMonth,
      logonDate = props.logonDate,
      logonYear = props.logonYear,
      logonTime = props.logonTime,
      logonTimezone = props.logonTimezone;

  if (language === 'en') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AccessibilityText, null, getAccessibilityMessage(props)), /*#__PURE__*/React.createElement("div", {
      "aria-hidden": true
    }, /*#__PURE__*/React.createElement("span", null, "Your last sign on was"), /*#__PURE__*/React.createElement("span", null, logonMonth, " ", logonDate, ", ", logonYear, " at"), /*#__PURE__*/React.createElement("span", null, logonTime, " ", logonTimezone)));
  } else if (language === 'sp') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AccessibilityText, null, getAccessibilityMessage), /*#__PURE__*/React.createElement("div", {
      "aria-hidden": true
    }, /*#__PURE__*/React.createElement("span", null, "La \xFAltima vez que inici\xF3 sesi\xF3n fue el"), /*#__PURE__*/React.createElement("span", null, logonDate, " de ", logonMonth, " de ", logonYear, " a la(s) "), /*#__PURE__*/React.createElement("span", null, logonTime, ", ", logonTimezone)));
  } else {
    throw new Error("Unexpected language code: ".concat(language, "."));
  }
};

var LastLogon = function LastLogon(_ref2) {
  var lastLogonTimeStamp = _ref2.lastLogonTimeStamp,
      fallback = _ref2.fallback,
      timeZone = _ref2.timeZone;

  var _useStrings = useStrings(),
      getString = _useStrings.getString;

  var _useLanguage = useLanguage(),
      language = _useLanguage.language;

  var messageParts = getLastLogonMessageParts({
    language: language,
    getString: getString,
    timeZone: timeZone,
    lastLogonTimeStamp: lastLogonTimeStamp
  });

  if (messageParts === undefined) {
    logger.warn('Unable to construct last logon message');
    return /*#__PURE__*/React.createElement(Block, {
      layout: true,
      vertical: true,
      center: true,
      className: styles.lastLogon,
      tabIndex: "-1",
      "data-last-logon": true
    }, /*#__PURE__*/React.createElement(Markup, {
      el: "div",
      content: fallback
    }));
  } // Without the onclick handler below, VoiceOver triggers a navigation
  // (from an item below this component) in response to a click event.


  return /*#__PURE__*/React.createElement(Block, {
    layout: true,
    vertical: true,
    center: true,
    className: styles.lastLogon,
    tabIndex: "-1",
    onClick: function onClick(e) {
      return e.preventDefault();
    },
    "data-last-logon": true
  }, getFormattedMessage(_objectSpread({
    language: language
  }, messageParts)));
};

export default LastLogon;